/*@ngInject*/
const FunctionActionUtil = function ($window, $stateParams, customButtonFunctionType, modalUtil,
                                     coreMediator, loadingBarHandler, remoteFunction) {

    this.handleAction = function (action, submission, identifierName, identifier, contextParameters) {
        if (action.functionType === customButtonFunctionType.URL) {
            handleUrlAction(action, submission, identifierName, identifier, contextParameters);
        } else if (action.functionType === customButtonFunctionType.REMOTE_FUNCTION) {
            handleRemoteFunctionAction(action, submission, identifierName, identifier, contextParameters);
        }
    };

    this.getParameterAsObject = function (parameters) {
        let parameterArray,
            index,
            name,
            value,
            parameterObject = {};

        parameterArray = _.split(parameters, '::');
        _.forEach(parameterArray, function (parameter) {
            index = _.indexOf(parameter, '=');
            name = parameter.substring(0, index);
            value = parameter.substring(index + 1);
            parameterObject[name] = value;
        });
        return parameterObject;
    };

    this.constructUrl = function (parameters, submissionId, userProfile) {
        let url = parameters.url;
        if(url.includes('?')) {
            url += '&';
        } else {
            url += '?';
        }
        url += 'submissionId=' + submissionId;
        if ($stateParams.formId) {
            url += `&formId=${!_.isNil($stateParams.formSummaryInstanceId) ? $stateParams.formSummaryInstanceId : $stateParams.formId }`
        }
        _.forOwn(parameters, function (parameterValue, parameterName) {
            if (parameterName !== 'url') {
                url += '&' + parameterName + '=' + encodeURIComponent(parameterValue);
            }
        });

        return coreMediator.getSingleUseToken().then((token) => {
            return url += '&t=' + encodeURIComponent(token);
        });
    };

    let handleUrlAction = function (action, submission, identifierName, identifier, contextParameters) {
        let translations,
            parameters;

        let openUrl = function () {
            parameters = this.getParameterAsObject(action.parameters);

            if (_.has(parameters, 'url') && !_.isNull(submission)) {

                function getFormattedPolicyNumbers(policyNumber) {
                    let policyNumbers = '',
                        policyNumberArray = _.split(policyNumber, ',');

                    _.each(policyNumberArray, (value, index) => {
                        if (index > 0) {
                            policyNumbers += ',';
                        }
                        policyNumbers += _.trim(value);
                    });

                    return policyNumbers;
                }

                let policyNumbers = '';
                if (!_.isNil(submission.policyNumber)) {
                    policyNumbers = getFormattedPolicyNumbers(submission.policyNumber);
                    policyNumbers += !_.isNil(submission.expiringPolicyNumber) ? ',' + getFormattedPolicyNumbers(submission.expiringPolicyNumber) : '';
                } else if (!_.isNil(submission.expiringPolicyNumber)) {
                    policyNumbers = getFormattedPolicyNumbers(submission.expiringPolicyNumber);
                }

                parameters['url'] = _.replace(parameters['url'], '{0}', policyNumbers);
            }

            if (!_.isNil(identifierName)) {
                parameters[identifierName] = identifier;
            }
            coreMediator.loadUserProfile().then(function (userProfile) {
                this.constructUrl(parameters, submission.id, userProfile).then((url) => {
                    if (!_.isNil(contextParameters)) {
                        url += '&' + _.replace(contextParameters, /::/g, '&');
                    }
                    $window.open(url);
                });
            }.bind(this));
        }.bind(this);

        if (action.confirmationMessage) {
            translations = {
                cancelButtonLabel: action.noButtonLabel,
                confirmActionButtonLabel: action.yesButtonLabel,
                summary: action.confirmationMessage,
                title: action.confirmationTitle
            };
            modalUtil.showGenericConfirm(translations).then(openUrl);
        } else {
            openUrl();
        }
    }.bind(this);

    let handleRemoteFunctionAction = function (action, submission, identifierName, identifier, contextParameters) {
        let translations;

        let executeRemoteFunction = function (contextParameters) {
            let parameters = this.getParameterAsObject(action.parameters);

            if (!_.isNil(identifierName)) {
                parameters[identifierName] = identifier;
            }

            if (!_.isNil(contextParameters)) {
                let contextParametersArray,
                    contextParametersNameValuePair;
                if (contextParameters.includes('::')){
                    contextParametersArray = contextParameters.split('::');
                    for (var i=0; i < contextParametersArray.length; i++){
                        contextParametersNameValuePair = contextParametersArray[i].split('=');
                        parameters[contextParametersNameValuePair[0]] = contextParametersNameValuePair[1];
                    }
                }else {
                    contextParametersNameValuePair = contextParameters.split('=');
                    parameters[contextParametersNameValuePair[0]] = contextParametersNameValuePair[1];
                }
            }

            if (action.processingIndicatorText) {
                loadingBarHandler.showLoadingBar(action.processingIndicatorText);
            }

            // Passing -1 for the formId will cause the REST url to be /rest/Form/-1/execute, which just
            // indicates that the remote function is not associated with a specific form. This will not fail.
            remoteFunction.executeFunction(-1, null, null, parameters, submission.id).then(function (executorResult) {
                if (executorResult.url) {
                    parameters.url = executorResult.url;
                }

                if (parameters.url) {
                    coreMediator.loadUserProfile().then(function (userProfile) {
                        this.constructUrl(parameters, submission.id, userProfile).then((url) => {
                            $window.open(url);
                        });
                    }.bind(this));
                }

                loadingBarHandler.hideLoadingBar();
            }.bind(this));
        }.bind(this);

        if (action.confirmationMessage) {
            translations = {
                cancelButtonLabel: action.noButtonLabel,
                confirmActionButtonLabel: action.yesButtonLabel,
                summary: action.confirmationMessage,
                title: action.confirmationTitle
            };
            modalUtil.showGenericConfirm(translations).then(executeRemoteFunction);
        } else {
            executeRemoteFunction(contextParameters);
        }
    }.bind(this);
};

angular.module('umCore')
    .service('functionActionUtil', FunctionActionUtil);
